<template>
    <div
        v-if="items"
        class="relationship"
    >
        <div class="top">
            <SearchField v-model="currentSearch"/>
        </div>
        <div class="columns flex">
            <div class="leftColumn column">
                <ul class="list list-reset">
                    <li
                        v-for="item in shownItems"
                        :key="item.id"
                        :class="{ 'disabled': activeItems.includes(item.id) || isDisabled }"
                        class="item"
                        @click="$emit('addItem', item)"
                    >
                        <span class="label">
                            {{ item.title }}
                        </span>
                    </li>
                </ul>
            </div>
            <div class="rightColumn column">
                <ul class="list list-reset">
                    <draggable
                        :list="activeItems"
                        tag="span"
                        ghost-class="ghost"
                    >
                        <transition-group>
                            <li
                                v-for="item in activeItems"
                                v-show="activeItemExists(item)"
                                :key="item"
                                class="item move"
                            >
                                <span class="label">
                                    {{ getLabelForActive(item) }}
                                </span>
                                <svg svg-inline="" class="deleteIcon" @click="removeItem(item)" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM18 9l-6 6M12 9l6 6"/></svg>
                            </li>
                        </transition-group>
                    </draggable>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable-next-line */
import Fuse from 'fuse.js';
import draggable from 'vuedraggable';
import SearchField from '../ui/SearchField.vue';
import { get } from '../../utils/apiHelper';

export default {
    components: {
        draggable,
        SearchField,
    },
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        activeItems: {
            type: Array,
            required: true,
        },
        excludeId: {
            type: Number,
            default: null,
        },
        max: {
            type: Number,
            default: null,
        },
        shortArticleNumber: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        items: null,
        currentSearch: null,
    }),
    computed: {
        shownItems() {
            let items = this.items.slice(0);

            if (this.excludeId) {
                items = items.filter(item => item.id !== this.excludeId);
            }

            if (this.currentSearch) {
                return this.searchItems(items);
            }

            return items;
        },
        isDisabled() {
            if (!this.max) return false;

            return this.activeItems.length >= this.max;
        },
    },
    async created() {
        this.items = await get(this.endpoint);

        if (this.shortArticleNumber) {
            this.items.map((item) => {
                /* eslint-disable-next-line */
                item.title = `${item.title} - ${item.article_number}`;
                return item;
            });
        }
    },
    methods: {
        activeItemExists(id) {
            return this.items.find(item => item.id === id);
        },
        getLabelForActive(id) {
            const active = this.items.find(item => item.id === id);

            if (!active) {
                return '';
            }

            return active.title;
        },
        selectItem(item) {
            this.activeItems.push(item);
        },
        removeItem(item) {
            const index = this.activeItems.indexOf(item);
            if (index !== -1) {
                this.$emit('removeItem', index);
            }
        },
        searchItems(items) {
            const fuse = new Fuse(items, {
                threshold: 0.3,
                shouldSort: true,
                keys: [
                    {
                        name: ['title'],
                        weight: 1,
                    },
                ],
            });

            return fuse.search(this.currentSearch);
        },
    },
};
</script>

<style lang="postcss" scoped>
.top {
    margin-bottom: -1px;
    & >>> .inputField {
        border-radius: 0;
        border-top-left-radius: var(--borderRadius);
        border-top-right-radius: var(--borderRadius);
    }
}
.column {
    width: 50%;
    border: 1px solid var(--borderColor);
}
.leftColumn {
    background: var(--grey100);
    border-right: 0;
    border-bottom-left-radius: var(--borderRadius);
}
.rightColumn {
    border-bottom-right-radius: var(--borderRadius);
}
.list {
    padding: 8px;
    height: 180px;
    overflow: auto;
}
.item {
    position: relative;
    font-size: 14px;
    padding: 6px 8px;
    cursor: pointer;
    transition: var(--normalTrans);
    @media (--laptop) {
        font-size: 13px;
    }
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    &:hover:not(.sortable-chosen) {
        background-color: var(--primary);
        color: #fff;
    }
}
.deleteIcon {
    position: absolute;
    color: #fff;
    cursor: pointer;
    width: 18px;
    height: 18px;
    right: 8px;
    top: 50%;
    margin-top: -9px;
    opacity: 0;
    transition: var(--normalTrans);
    @media (--laptop) {
        width: 16px;
        height: 16px;
        margin-top: -8px;
    }
}
.item.move:hover {
    cursor: move;
    & .deleteIcon {
        opacity: 1;
    }
}
.item.ghost {
    background-color: var(--grey300);
}
</style>
